module.exports = __webpack_public_path__ + "img/apple-pay-payment-mark-logo-174E25DB63-seeklogo.com.6a70dfff.png";